/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNavigationV = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 13v6H6v-6zm-2 2H8v2h12zm2-10v6H6V5zM4 5v6H2V5zm16 2H8v2h12z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNavigationV as NavigationV };
